import React from 'react'

interface IconFontProps {
  name: string
  type?: 'fontClass' | 'symbol'
  size?: number
  color?: string
  className?: string
  style?: React.CSSProperties
}

const IconFont: React.FC<IconFontProps> = (props) => {
  const { type = 'symbol', name, size = 18, color, className, style } = props

  const fontStyle = {
    color: color ? `#${color}` : '',
    fontSize: size ? `${size}px` : '',
  }

  const symbolStyle = {
    width: '1em',
    height: '1em',
    color: color ? `#${color}` : '',
    fontSize: size ? `${size}px` : '',
    verticalAlign: '-0.125em',
    fill: 'currentColor',
    overflow: 'hidden',
  }
  return (
    <span className={`tw-leading-0 ${className}`} style={style}>
      {type === 'fontClass' ? (
        <span className={`iconfont icon-${name}`} style={fontStyle}></span>
      ) : (
        <svg aria-hidden="true" style={symbolStyle}>
          <use xlinkHref={`#icon-${name}`}></use>
        </svg>
      )}
    </span>
  )
}

export default IconFont
